import { PagerDutyData } from './types';

export const usePagerDutyData = (
  _repositoryValue: string,
): {
  data: PagerDutyData | null;
  loading: boolean;
} => {
  // PagerDuty integration is manual input only, no auto-detection
  // Return null data and no loading state
  return {
    data: null,
    loading: false,
  };
};
